module.exports = __webpack_public_path__ + "static/media/playstore.1c69581f.png";